import { render, staticRenderFns } from "./OptionButton.vue?vue&type=template&id=31ec66d1&"
import script from "./OptionButton.vue?vue&type=script&lang=js&"
export * from "./OptionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports